import styled from '@emotion/styled'
import {motion} from 'motion/react'

import {cssTheme} from '../../../../themes'
import {BasicTagElement} from '../../Tag'
import {DOT_WIDTH} from './constants'
import {PaginationWrapper} from './PaginationButtons'

export const PanesAmountWrapper = styled.div`
  position: absolute;
  bottom: ${cssTheme.layout.spacing.s400};
  right: ${cssTheme.layout.spacing.s500};
  color: ${cssTheme.colors.content.neutral.inverse};
  z-index: 1;
  &.--transparent-background {
    ${BasicTagElement} {
      background-color: transparent;
    }
  }
`

export const IndicatorWrapper = styled.div`
  position: absolute;
  height: 44px;
  bottom: 0;
  width: 100%;
  z-index: 1;
  &.--has-dark-gradient {
    background: linear-gradient(
      0deg,
      ${cssTheme.colors.background.neutral.overlay} 0%,
      transparent 100%
    );
  }
`

export const DotIndicator = styled(motion.div)`
  position: absolute;
  width: ${DOT_WIDTH}px;
  height: ${DOT_WIDTH}px;
  background-color: ${cssTheme.colors.background.neutral.primary};
  border-radius: 50%;
  bottom: ${cssTheme.layout.spacing.s500};

  &.--inverse-color {
    background-color: ${cssTheme.colors.background.neutral.inversePrimary};
  }

  &.--is-rtl {
    right: 0;
  }
  &.--is-ltr {
    left: 0;
  }
`

export const PaneStyled = styled(motion.div)`
  position: absolute;
  width: 100%;
  height: 100%;
  background-color: ${cssTheme.colors.background.neutral
    .inversePrimary}; //check with nicole
  will-change: transform, left, right;
`

export const Pinchable = styled(motion.div)`
  width: 100%;
  height: 100%;
`

export const FullSizeWrapper = styled.div`
  width: 100%;
  height: 100%;
`

export const Container = styled(motion.div)<{
  width: number
}>`
  position: relative;
  height: 100%;
  width: 100%;
  width: ${({width}) => width}px;
  background-color: ${cssTheme.colors.background.neutral.inversePrimary};
  overflow: hidden;

  &.--show-pagination-on-hover {
    ${PaginationWrapper} {
      opacity: 0 !important;
      transition: opacity 0.2s ease-in-out;
    }

    &:hover {
      ${PaginationWrapper} {
        opacity: 1 !important;
      }
    }
  }
`
